<template>
  <div id="tasklistTc" :class="['tc','bigIconBox', bigclicknum==1?'':'biganimation']">
    <div class="img">
      <img :src="obj.bigPicSrc" class="imgBlock"/>
    </div>

    <div class="centerInfo">
      <p>{{ obj.medalname }}</p>
      <p>{{ obj.title }}</p>
      <!-- <p>2019-05-16到期</p> -->
      <div class="backBtn" @click="close">返回</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tasklistTc",
  props: ["obj","clicknum"],
  data() {
    return {
      bigclicknum: 0
    };
  },
  mounted() {},
  methods: {
    /**通知父组件关闭该弹窗 */
    close() {
      this.$emit("close_big_img", true);
      this.bigclicknum = this.clicknum-0 + 1
    }
  }
};
</script>

<style scoped>
/* 点击活动的弹出框样式 */
.bigIconBox .img {
  width: 80%;
  margin: 0 auto;
  min-height: 50%;
  
}
.biganimation .img{
  -webkit-animation: show-f-top 0.3s ease-out;
  animation: show-f-top 0.3s ease-out;
}
/* 图片显示的动画 */
/*元素从顶部滑到屏幕中间*/
@keyframes show-f-top {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
@-webkit-keyframes show-f-top {
  /* Safari 和 Chrome */
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

/* 活动弹出的大图片盒子 */
.bigIconBox .centerInfo {
  /* position: absolute; */
  top: 330px;
  width: 100%;
  text-align: center;
  -webkit-animation: fadein 0.4s ease-in;
  animation: fadein 0.4s ease-in;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  /* Safari 和 Chrome */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.bigIconBox .centerInfo p:nth-child(1) {
  color: #fff;
  font-size: 20px;
  height: 50px;
  line-height: 50px;
}
.bigIconBox .centerInfo p:nth-child(2) {
  color: #fff;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}
.bigIconBox .centerInfo p:nth-child(3) {
  color: #fff;
  font-size: 12px;
  height: 50px;
  line-height: 50px;
}
/* 返回按钮的样式 */
.bigIconBox .backBtn {
  bottom: 150px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  text-align: center;
  font-size: 14px;
  color: #bb3215;
  background: linear-gradient(#f9d352, rgb(238, 173, 20));
  margin: 0 auto;
}
</style>